import { FinanceProvider } from '@kanda-libs/ks-frontend-services';

export type LenderStatus =
  | 'loading'
  | 'finished'
  | 'sat_note_delayed'
  | 'sat_note'
  | 'under_review'
  | 'cancelled'
  | 'action_required'
  | 'referred'
  | 'declined'
  | 'sign_documents'
  | 'accepted'
  | 'not_approved'
  | 'ready_to_start'
  | 'deposit'
  | 'pending'
  | 'lender_review';

interface Provider {
  name: string;
  contact: {
    email: string;
    phone: string;
    hours?: string[];
  };
}

export const PROVIDERS: Record<FinanceProvider, Provider> = {
  omni: {
    name: 'Omni Capital Retail Finance',
    contact: {
      email: 'customerenquiries@ocrf.co.uk',
      phone: '0333 240 8317',
      hours: ['Monday - Friday, 9am - 5:30pm', 'Saturday/Sunday - Closed'],
    },
  },
  allium: {
    name: 'Tandem Bank',
    contact: {
      email: 'customersupport@tandem.co.uk',
      phone: '01290 211 495',
      hours: ['Monday - Friday, 9am - 5:00pm', 'Saturday/Sunday - Closed'],
    },
  },
  propensio: {
    name: 'Propensio Finance Limited',
    contact: {
      email: 'info@propensio.co.uk',
      phone: '01709 808 990',
      // hours: ['Monday - Friday, 9am - 5:30pm', 'Saturday/Sunday - Closed'],
    },
  },
  etika: {
    name: 'Etika Finance UK Limited',
    contact: {
      email: 'hello.uk@etika.com',
      phone: '0800 028 9321',
      hours: [
        'Monday - Friday, 8am - 6pm',
        'Saturday, 10am - 2pm',
        'Sunday - Closed',
      ],
    },
  },
  humm: {
    name: 'Humm Group Limited ',
    contact: {
      email: 'contactuk@shophumm.com',
      phone: '028 9142 2113',
      hours: ['Monday - Friday, 9am - 5:00pm', 'Saturday/Sunday - Closed'],
    },
  },
  demo: {
    name: 'Ideal4Finance',
    contact: {
      email: 'cs@ideal4finance.co.uk',
      phone: '020 3841 2818',
      hours: ['Monday - Friday, 9am - 5:30pm', 'Saturday/Sunday - Closed'],
    },
  },
  novuna: {
    name: 'Novuna Personal Finance',
    contact: {
      email: 'customerservice@novunapersonalfinance.co.uk',
      phone: '0344 375 5500',
      hours: ['Monday - Friday, 9am - 6:00pm', 'Saturday/Sunday - Closed'],
    },
  },
};
